import React from 'react';
import { motion } from 'framer-motion';
import { trackEvent } from '../lib/fpixel';
export function Hero() {
  const scrollToPricing = () => {
    trackEvent('InitiateCheckout');
    document.getElementById('precios')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const badges = ['📄 100% PDF', '⚡ Acceso Inmediato', '📚 12 Tomos + 6 Bonos'];
  return <section className="w-full bg-[#F6FAF8] px-4 min-h-screen md:min-h-0 flex items-center py-4 md:py-20" data-id="element-231">
      <div className="max-w-5xl mx-auto w-full" data-id="element-232">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center space-y-3 md:space-y-7" data-id="element-233">
          {/* Eyebrow pill */}
          <div className="flex justify-center" data-id="element-234">
            <span className="bg-[#E3F2EC] text-[#2F6B57] px-4 py-1.5 md:py-2 rounded-full text-[10px] sm:text-xs md:text-sm font-bold tracking-wide uppercase shadow-sm border border-[#CFE7DC]" data-id="element-235">
              🦴 Sistema de Estudio · Kinesiólogos Argentina
            </span>
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-extrabold leading-[1.05] tracking-tight" data-id="element-236">
            <span className="block text-slate-900" data-id="element-237">
              Toda la carrera de Kinesiología organizada en un solo lugar.
            </span>
          </h1>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} className="flex justify-center" data-id="element-238">
            <img src="https://cdn.magicpatterns.com/uploads/qGkhPFpGttaPGSVBLSzaSv/ebd164d3-450b-4694-ba25-4083a3d56919.png" alt="Kinesiología: Rescate Académico — Megapack Edición Élite con 12 tomos completos, 6 PDF bonus y 2 PDF élite" width={672} height={672} fetchpriority="high" decoding="async" className="w-full max-w-[240px] sm:max-w-[340px] md:max-w-2xl h-auto drop-shadow-2xl" data-id="element-239" />
          </motion.div>

          <h2 className="text-base sm:text-lg md:text-2xl font-bold max-w-3xl mx-auto text-[#2F6B57]" data-id="element-240">
            Kinesiología: Rescate Académico — Sistema Completo · 12 Tomos + 6
            Bonos
          </h2>

          <p className="text-sm sm:text-base md:text-lg font-medium max-w-2xl mx-auto text-slate-600" data-id="element-241">
            El sistema completo para estudiantes que quieren aprobar con
            criterio, dominar las prácticas hospitalarias y recibirse sin perder
            años.
          </p>

          <p className="hidden md:block text-lg md:text-xl text-slate-600 font-medium max-w-3xl mx-auto italic" data-id="element-242">
            "280 páginas de Kinesiología argentina organizada, práctica y
            aplicable. Del primer parcial al título, con los 2 Ebooks Élite que
            te dan autoridad clínica desde el día uno."
          </p>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.3
        }} className="flex flex-nowrap justify-center items-center gap-1.5 md:gap-3 pt-1 md:pt-4" data-id="element-243">
            {badges.map((badge, i) => <motion.span key={i} initial={{
            opacity: 0,
            scale: 0.8
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.4 + i * 0.05
          }} className="bg-white text-slate-700 px-2 md:px-4 py-1 md:py-2 rounded-full text-[9px] sm:text-[10px] md:text-sm font-medium border border-slate-200 shadow-sm whitespace-nowrap" data-id="element-244">
                {badge}
              </motion.span>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6
        }} className="pt-2 md:pt-6" data-id="element-245">
            <motion.button whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} onClick={scrollToPricing} className="w-full max-w-lg mx-auto bg-[#2F6B57] hover:bg-[#255645] text-white font-bold text-sm sm:text-base md:text-xl px-5 sm:px-8 md:px-12 py-3.5 md:py-5 rounded-xl shadow-xl shadow-[#2F6B57]/30 transition-colors" data-id="element-246">
              🎓 → QUIERO MI RESCATE ACADÉMICO AHORA
            </motion.button>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.8
        }} className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 pt-1 md:pt-3 text-slate-500 text-[11px] md:text-sm font-medium" data-id="element-247">
            <span className="flex items-center gap-1.5" data-id="element-248">
              🛡️ Garantía 7 días
            </span>
            <span className="text-slate-300" data-id="element-249">|</span>
            <span className="flex items-center gap-1.5" data-id="element-250">🔒 Pago seguro</span>
            <span className="text-slate-300" data-id="element-251">|</span>
            <span className="flex items-center gap-1.5" data-id="element-252">
              💳 Mercado Pago · Tarjeta · Transferencia
            </span>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}